/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guides_Path_P2Inputs */

const en_guides_path_p2 = /** @type {(inputs: Guides_Path_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you already ship JSON and are choosing between formats or designing an API, start with JSON vs YAML vs XML and JSON in REST APIs.
Add JSON Schema when you need the shape enforced rather than documented.`)
};

const ko_guides_path_p2 = /** @type {(inputs: Guides_Path_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미 JSON을 다루면서 형식을 고르거나 API를 설계하는 중이라면 JSON vs YAML vs XML과 REST API 편이 먼저입니다.
구조를 문서로 적어두는 수준을 넘어 강제해야 할 때 JSON Schema 편을 더하세요.`)
};

const ja_guides_path_p2 = /** @type {(inputs: Guides_Path_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すでにJSONを扱っていて形式を選ぶ段階、あるいはAPIを設計する段階なら、JSON vs YAML vs XMLとREST API編が先です。
構造を文書に書き留めるだけでなく強制する必要が出てきたら、JSON Schema編を加えてください。`)
};

/**
* | output |
* | --- |
* | "If you already ship JSON and are choosing between formats or designing an API, start with JSON vs YAML vs XML and JSON in REST APIs. Add JSON Schema when you..." |
*
* @param {Guides_Path_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guides_path_p2 = /** @type {((inputs?: Guides_Path_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guides_Path_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guides_path_p2(inputs)
	if (locale === "ko") return ko_guides_path_p2(inputs)
	return ja_guides_path_p2(inputs)
});